export default "__VITE_ASSET__BtylBbDv__"